import React, { useEffect, useRef, useState } from "react";
import { useHistory, Redirect } from "react-router";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import * as R from "ramda";
import * as Loadings from "../../../constants/loadings/backoffice/aidavie";
import { LoadingState } from "../../../_common/loadingState";

import { AidavieFilter } from "./filter";
import { AidaviePagination } from "./pagination";

export const AidavieMain = ({ aidavieState, partners, pageSearch, setPageSearch, routerQuery, operatorId, pageQuery, teleconseillers, isPartner, userId }) => {
	const history = useHistory();
	const dispatch = useDispatch();

	const [usersToDisplay, setUsersToDisplay] = useState(aidavieState.items);
	const [partnersToDisplay, setPartnersToDisplay] = useState(partners);
	const [teleconseillersToDisplay, setTeleconseillersToDisplay] = useState(partners);
	const operatorIdOptions = { myUsers: "Mes fiches", allUsers: "Toutes les fiches" };

	const searchRef = useRef();
	let timer = null;

	const [selectedUser, setSelectedUser] = useState(undefined);

	useEffect(() => {
		if (!R.isNil(searchRef.current) && pageSearch !== "") {
			searchRef.current.focus();
		}

		const pageQuery = new URLSearchParams(window.location.search);
		if (pageSearch == "") {
			pageQuery.delete("search");
			history.push(`/backoffice/aidavie?${pageQuery.toString()}`);
			return;
		}
		pageQuery.set("search", pageSearch);

		clearTimeout(timer);
		timer = setTimeout(() => {
			history.push(`/backoffice/aidavie?${pageQuery.toString()}`);
		}, 1000);

		return () => clearTimeout(timer);
	}, [pageSearch]);

	useEffect(() => {
		setPartnersToDisplay(partners);
	}, [partners]);

	useEffect(() => {
		setTeleconseillersToDisplay(teleconseillers);
	}, [teleconseillers]);

	useEffect(() => {
		setUsersToDisplay(aidavieState.items);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [aidavieState]);

	if (window.location.search === "") {
		return (
			<Redirect
				to={`/backoffice/aidavie?page=${1}&operatorId=${operatorId}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}${!R.isNil(routerQuery.fromCreationDate) ? "&fromCreationDate=" + routerQuery.fromCreationDate : ""}${!R.isNil(routerQuery.toCreationDate) ? "&toCreationDate=" + routerQuery.toCreationDate : ""}`}
			/>
		);
	}

	return (
		<article className="view-calc pt-3 mb-auto pb-sm pt-gd-3 pt-lg-4">
			<div className="container-fluid">
				<AidavieFilter
					aidavieState={aidavieState}
					operatorIdOptions={operatorIdOptions}
					searchRef={searchRef}
					pageSearch={pageSearch}
					setPageSearch={setPageSearch}
					partnersToDisplay={partnersToDisplay}
					routerQuery={routerQuery}
					operatorId={operatorId}
					pageQuery={pageQuery}
					teleconseillers={teleconseillersToDisplay}
					userId={userId}
				/>
			</div>
			<div className="auto-view h-100 mb-auto">
				{aidavieState.isLoading.includes(Loadings.FETCHING_AIDAVIE_FILES) ? (
					<LoadingState />
				) : (
					<div className="container-fluid">
						{!R.isEmpty(usersToDisplay) ? (
							<section className="block grid-sm grid-sm-min grid-lg-narrow grid-hd-auto">
								{usersToDisplay.map((user) => {
									return (
										<div className="card text-center h-100 rounded shadow--hover" key={user.id}>
											<div className="card-body my-auto px-3 flex-column">
												{/* <div className="card-body pt-3 pb-2 shadow h-100 rounded mb-2 text-center"> */}
												<h4 className="h3 ls-n1 font-weight-black  mb-2 text-capitalize">{!R.isNil(user.firstName) && user.firstName !== "" && !R.isNil(user.lastName) && user.lastName !== "" ? `${user.firstName} ${user.lastName}` : "Non complété"}</h4>
												{user.agesmaId && (
													<p className="h6 text-uppercase font-weight-bolder mb-0">
														<span className="o-40">Premium</span>
													</p>
												)}
											</div>
											<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder pt-1 bg-light">
												<span className="o-60">Email: </span>
												<span className="mx-1">{user.email}</span>
											</div>
											<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder pb-1 bg-light">
												<span className="o-60">Évènement de vie: </span>
												<span className="text-uppercase mx-1">
													{user.lifeEvent ? 
														user.lifeEvent.toUpperCase() === "DEATH" ? "Décès" :
														user.lifeEvent.toUpperCase() === "RELOCATION" ? "Déménagement" :
														user.lifeEvent.toUpperCase() === "RETIREMENT" ? "Passage à la retraite" :
														user.lifeEvent.toUpperCase() === "MAJORITY" ? "Passage majorité" :
														user.lifeEvent.toUpperCase() === "MARRIAGE" ? "Mariage" :
														user.lifeEvent.toUpperCase() === "BIRTH" ? "Naissance" :
														user.lifeEvent.toUpperCase() === "DIVORCE" ? "Divorce" :
														user.lifeEvent
														: "Non défini"}
												</span>
											</div>
											<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder pb-1 bg-light">
												<span className="o-60">Etape: </span>
												<span className="text-uppercase mx-1">{user.step === 0 ? "Création de compte" : user.step === 1 ? "Évènement de vie" : user.step === 2 ? "Données personnelles" : user.step === 3 ? "Démarches" : user.step === 4 ? "Bilan" : user.step}</span>
											</div>
											
											<div className="flex-row fs-2 mx-auto mb-auto justify-content-between align-items-center px-3 w-100 font-weight-bolder py-2">
												<div>
													<span className="o-60">Partenaire: </span>
													{/* Warning, partner is null here. We need to make sure partners is loaded before. */}
													<span className="text-uppercase mx-1">{partners?.find((p) => user.partnerId === p.id)?.name}</span>
												</div>
											</div>
										</div>
									);
								})}
							</section>
						) : (
							<div className="flex-column p-3 mt-5 h-100 ">
								<div className="container container-base text-center m-auto">
									<h5 className="sr-only visually-hidden">Agent - Empty</h5>
									<div className="display-4 font-weight-black ls-n1 lh-1 mb-3">Aucun résultat</div>
									<p className="text-lg mb-4 o-66">Veuillez vérifier que les filtres appliqués correspondent bien à votre recherche.</p>
								</div>
							</div>
						)}
					</div>
				)}
			</div>
			<div className="container-fluid">
				<AidaviePagination aidavieState={aidavieState} pageSearch={pageSearch} routerQuery={routerQuery} />
			</div>
		</article>
	);
};
